module.exports = __webpack_public_path__ + "img/img_0@2x.98b7e607.png";